var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.storeInfo.storeId>0||_vm.storeInfo.type==99||_vm.storeInfo.type==2)?_c('Wrap'):_c('ChooseHotel',{ref:"chooseHotel"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }